import  ApiService  from '../../services/api.service'

const state =  {
    modelList: [],
    tyreList: [],
    tyreModelList: [],
    tyreTypeTyreList: [],
    tyreSeasonTyreList: [],
    tyreSizeTyreList: [],
    pageDetails: {}
}
const getters = {
    modelList: state => state.modelList,
    tyreList: state => state.tyreList,
    tyreModelList: state => state.tyreModelList,
    tyreTypeTyreList: state => state.tyreTypeTyreList,
    tyreSeasonTyreList: state => state.tyreSeasonTyreList,
    tyreSizeTyreList: state => state.tyreSizeTyreList,
    pageDetails: state => state.pageDetails
}

const mutations = {
    setModels(state, value) {
        state.modelList = value;
    },
    setTyres(state, value) {
        state.tyreList = value;
    },
    setModelTyres(state, value) {
        state.tyreModelList = value;
    },
    setTyreTypeTyreList(state, value) {
        state.tyreTypeTyreList = value;
    },
    setTyreSeasonTyreList(state, value) {
        state.tyreSeasonTyreList = value;
    },
    setPageDetails(state, value) {
        state.pageDetails = value
    },
    setTyreSizeTyreList(state, value) {
        state.tyreSizeTyreList = value
    },
}

const actions = {
    fetchModels({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/brand/' + obj.brandname + '/models' + obj.queryString)
            .then(response => {
                if (response.data.data) {
                    commit('setModels', response.data.data)
                }
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyres({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/brand/' + obj.brandname + '/tyres' + obj.queryString)
            .then(response => {
                if (response.data.data) {
                    commit('setTyres', response.data.data)
                }
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchPageDetails({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/page/' + obj.type + '/' + obj.type_name)
            .then(response => {
                commit('setPageDetails', response.data) 
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchModelTyres({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-model-tyres/' + obj.brandname + '/' + obj.modelname + obj.queryString)
            .then(response => {
                commit('setModelTyres', response.data.data)
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyreTypeTyres({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-tyretype-tyres/' + obj.tyre_category + obj.queryString)
            .then(response => {
                commit('setTyreTypeTyreList', response.data.data)
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyreSeasonTyres({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-tyreseason-tyres/' + obj.tyre_season + obj.queryString)
            .then(response => {
                commit('setTyreSeasonTyreList', response.data.data)
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchBrandDetail({ commit }, slug) {
        return new Promise((resolve, reject) => {
            ApiService.get('/brand/' + slug)
            .then(response => {
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchSeasonDetail({ commit }, slug) {
        return new Promise((resolve, reject) => {
            ApiService.get('/tyre-season/' + slug)
            .then(response => {
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchModelDetail({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/brand/' + obj.brandSlug + '/model/' + obj.modelSlug)
            .then(response => {
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyrecategoryDetail({ commit }, slug) {
        return new Promise((resolve, reject) => {
            ApiService.get('/tyre_category/' + slug)
            .then(response => {
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyreSizeDetail({ commit }, slug) {

        return new Promise((resolve, reject) => {
            ApiService.get('/tyre-size/' + slug)
            .then(response => {
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
    fetchTyreSizeTyres({ commit }, obj) {
        return new Promise((resolve, reject) => {
            ApiService.get('/get-tyresize-tyres/' + obj.tyre_size + obj.queryString)
            .then(response => {
                commit('setTyreSizeTyreList', response.data.data)
                resolve(response)
            }).catch((e) => {
                reject(e)
            }).finally(() => {
            })
        });
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}